<template>
  <v-card class="pa-8">
    <v-overlay v-model="settingFilters">
      <v-progress-circular indeterminate size="32" />
    </v-overlay>
    <v-card-title
      v-if="areSettingsEmpty"
      class="error--text d-flex flex-column justify-center align-center"
    >
      <v-icon color="error">mdi-alert</v-icon>
      <span>Você não selecionou nenhum item nas configurações</span>
      <p class="primary--text">
        Clique no botão <v-icon>mdi-cog</v-icon> para configurar os filtros
      </p>
    </v-card-title>
    <validation-observer v-else-if="!settingFilters" v-slot="{ invalid }">
      <v-card-subtitle class="error--text"
        >Todos os campos abaixo são obrigatórios</v-card-subtitle
      >
      <v-card-text>
        <list-filtro-modal-item title="Data" v-if="showData">
          <template #items>
            <v-col v-if="params.data_inicio.visible">
              <validation-provider
                name="data início"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="De"
                  v-model="params.data_inicio.value"
                  :errors="errors"
                  v-mask="['##/##/####']"
                />
              </validation-provider>
            </v-col>
            <v-col v-if="params.data_fim.visible">
              <validation-provider
                name="data fim"
                v-slot="{ errors }"
                rules="required"
              >
                <conferencia-list-filtro-data
                  propLabel="Até"
                  v-model="params.data_fim.value"
                  :errors="errors"
                  v-mask="['##/##/####']"
                />
              </validation-provider>
            </v-col>
          </template>
        </list-filtro-modal-item>

        <list-filtro-modal-item title="Campos" v-if="showFields">
          <template #items>
            <list-filtro-modal-item-input
              v-if="params.path.visible"
              v-model="params.path.value"
              name="path"
              label="Path"
              icon="mdi-folder-question-outline"
            />
            <list-filtro-modal-item-input
              v-if="params.user.visible"
              v-model="params.user.value"
              name="user"
              label="Usuário (CPF, EMAIL, CELULAR ou NOME)"
              icon="mdi-text-account"
            />
          </template>
        </list-filtro-modal-item>
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between">
        <v-btn plain @click="$emit('close')">Cancelar</v-btn>
        <v-btn
          class="px-8"
          x-large
          color="primary"
          @click="search"
          :disabled="areSettingsEmpty || invalid"
          ><v-icon>mdi-database-search</v-icon>
          <span>Buscar</span>
        </v-btn>
      </v-card-actions>
    </validation-observer>
  </v-card>
</template>

<script>
import { data } from './_data'
import { computed } from './_computed'
import { methods } from './_methods'

import ConferenciaListFiltroData from '@/components/financeiro/conferencia/conferencia-list/ConferenciaListFiltroData'
import ListFiltroModalItem from '../ListFiltroModalItem.vue'
import ListFiltroModalItemInput from '../ListFiltroModalItemInput.vue'

// import { SENHA_ATENDIMENTO } from '@/utils/storages'
// const LOCAL_STORAGE_ID = SENHA_ATENDIMENTO

export default {
  name: 'ListFiltroModal',
  components: {
    ConferenciaListFiltroData,
    ListFiltroModalItem,
    ListFiltroModalItemInput,
  },
  data,
  computed,
  methods,
  async created() {
    this.settingFilters = true

    this.getParamsFilter()

    // this.UPDATE_PARAMS({ key: LOCAL_STORAGE_ID.storage, params: this.params })

    await this.showOnlySelectedOptionsAndGetItems()
    this.settingFilters = false
  },
}
</script>
